import Swal from 'sweetalert2';

export function getHTMLForSummaryPopup(title, fieldList){
    let fieldRowsHtml = '';

    fieldList.forEach(field => {

        fieldRowsHtml = fieldRowsHtml 
        + `<tr>`
        + `<td align='right' style='font-size:14px;font-weight:bold;padding-right:3px;${(field.is_calculated ? 'color:#0000ff' : '')}' width='50%'>${(field.label ? field.label + ':' : '&nbsp;')}</td>`
        + `<td align='left' style='font-size:14px;padding-left:2px;${(field.is_calculated ? 'color:#0000ff;font-weight:bold;' : '')}'>${(field.value ? field.value : '&nbsp;')}</td></tr>`;
    })
    return `<div style='border:1px solid black'>
    <table align='center' width='100%'><tr><td colspan="2"style="background-color: #0d6efd">
    <h6 style="color:white;">${title}</h6></td></tr>
    ${fieldRowsHtml}
    </table></div>`;
}

export function getHTMLForTablePopup(title, columns, rows, footerRow = null, emptyMessage = 'No records found.') {
    const headerHtml = columns.map((column) => (
        `<th style="padding:8px 10px;border:1px solid #cbd5e1;background-color:#0090d8;color:#fff;font-size:13px;text-align:center;vertical-align:middle;">${column.label}</th>`
    )).join('');

    const bodyHtml = rows.map((row) => (
        `<tr>${columns.map((column) => (
            `<td style="padding:7px 10px;border:1px solid #dbe4f3;font-size:13px;text-align:${column.align || 'left'};">${row[column.key] ?? ''}</td>`
        )).join('')}</tr>`
    )).join('');

    const footerHtml = footerRow ? (
        `<tr>${columns.map((column) => (
            `<td style="padding:8px 10px;border:1px solid #cbd5e1;background-color:#eef2ff;font-size:13px;font-weight:700;text-align:${column.align || 'left'};">${footerRow[column.key] ?? ''}</td>`
        )).join('')}</tr>`
    ) : '';

    return `<div style="max-height:65vh;overflow:auto;border:1px solid #94a3b8;border-radius:8px;">
    <table align="center" width="100%" cellspacing="0" cellpadding="0" style="border-collapse:collapse;">
    <thead><tr><th colspan="${columns.length}" style="padding:10px;background-color:#1e3a8a;color:#fff;font-size:15px;text-align:center;">${title}</th></tr>
    <tr>${headerHtml}</tr></thead>
    <tbody>${bodyHtml || `<tr><td colspan="${columns.length}" style="padding:16px;text-align:center;color:#64748b;">${emptyMessage}</td></tr>`}${footerHtml}</tbody>
    </table></div>`;
}

/**
 * Open a SweetAlert table popup for cancelled/inactive list rows.
 */
export function showCancelledRecordsPopup({
    title,
    columns,
    rows,
    footerRow = null,
    emptyTitle = 'Cancelled Records',
    emptyMessage = 'No cancelled records in the current list.',
    width = 980,
} = {}) {
    if (!rows || !rows.length) {
        Swal.fire(emptyTitle, emptyMessage, 'info');
        return;
    }
    const html = getHTMLForTablePopup(title || `Cancelled (${rows.length})`, columns || [], rows, footerRow);
    Swal.fire({
        html,
        width,
        confirmButtonText: 'Close',
    });
}
